export const GET_BANK_HOLIDAYS = 'GET_BANK_HOLIDAYS'
export const GET_BANK_HOLIDAYS_SUCCESS = 'GET_BANK_HOLIDAYS_SUCCESS'
export const GET_BANK_HOLIDAYS_FAILED = 'GET_BANK_HOLIDAYS_FAILED'

export const GET_BANK_HOLIDAY = 'GET_BANK_HOLIDAY'
export const GET_BANK_HOLIDAY_SUCCESS = 'GET_BANK_HOLIDAY_SUCCESS'
export const GET_BANK_HOLIDAY_FAILED = 'GET_BANK_HOLIDAY_FAILED'

export const CREATE_BANK_HOLIDAY = 'CREATE_BANK_HOLIDAY'
export const CREATE_BANK_HOLIDAY_SUCCESS = 'CREATE_BANK_HOLIDAY_SUCCESS'
export const CREATE_BANK_HOLIDAY_FAILED = 'CREATE_BANK_HOLIDAY_FAILED'

export const UPDATE_BANK_HOLIDAY = 'UPDATE_BANK_HOLIDAY'
export const UPDATE_BANK_HOLIDAY_SUCCESS = 'UPDATE_BANK_HOLIDAY_SUCCESS'
export const UPDATE_BANK_HOLIDAY_FAILED = 'UPDATE_BANK_HOLIDAY_FAILED'

export const DELETE_BANK_HOLIDAY = 'DELETE_BANK_HOLIDAY'
export const DELETE_BANK_HOLIDAY_SUCCESS = 'DELETE_BANK_HOLIDAY_SUCCESS'
export const DELETE_BANK_HOLIDAY_FAILED = 'DELETE_BANK_HOLIDAY_FAILED'
